import React from 'react';
import Image from 'next/image';
import laptopNext from '../../svgs/laptop_basic_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function LaptopAlertNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={laptopNext}
      alt={alt ?? 'Info'}
    />
  );
}
